import type {PS} from '@wix/document-services-types'
import documentModeInfo from '../documentMode/documentModeInfo'
import structureUtils from './structureUtils'
import {isHeadless} from '../utils/utils'

interface Gap {
    aboveHeader: number
    abovePagesContainer: number
    aboveFooter: number
}

const siteGapMaps = new WeakMap()

function getSiteGapMap(ps: PS): Gap {
    if (isHeadless(ps)) {
        throw new Error('GapMap is not supported in headless mode (Optimus)')
    }

    const viewMode = documentModeInfo.getViewMode(ps)

    const header = ps.pointers.components.getHeader(viewMode)
    const footer = ps.pointers.components.getFooter(viewMode)
    const pagesContainer = ps.pointers.components.getPagesContainer(viewMode)

    const headerLayout = structureUtils.getComponentLayout(ps, header)
    const pagesContainerLayout = structureUtils.getComponentLayout(ps, pagesContainer)
    const footerLayout = structureUtils.getComponentLayout(ps, footer)

    const headerBottom = headerLayout.y + headerLayout.height
    const pagesContainerBottom = pagesContainerLayout.y + pagesContainerLayout.height

    return {
        aboveHeader: headerLayout.y,
        abovePagesContainer: pagesContainerLayout.y - headerBottom,
        aboveFooter: footerLayout.y - pagesContainerBottom
    }
}

function createInitialGapMap(ps: PS): Gap {
    if (!siteGapMaps.has(ps)) {
        siteGapMaps.set(ps, getSiteGapMap(ps))
    }

    return siteGapMaps.get(ps)
}

function getInitialGapMap(ps: PS): Gap {
    if (isHeadless(ps)) {
        throw new Error('GapMap is not supported in headless mode (Optimus)')
    }

    return siteGapMaps.get(ps)
}

export default {
    createInitialGapMap,
    getInitialGapMap
}
